import React, { ReactNode } from 'react';

import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

import { getWordsCount } from '~/helpers/functions';

type MeasurementType = 'char' | 'word';

export const getCountText = (
  query: string,
  minCountWarning?: number,
  maxCountIndicator?: number,
  measurement: MeasurementType = 'char',
): { countText: string | null; minCountText: ReactNode | null } => {
  const { t } = useTranslation('error');

  const isValidString = query && typeof query === 'string';
  const currentCount = isValidString
    ? measurement === 'char'
      ? query.length
      : getWordsCount(query)
    : 0;

  const countText = maxCountIndicator
    ? `${currentCount}/${maxCountIndicator}`
    : null;

  const shouldShowMinWarning =
    minCountWarning &&
    isValidString &&
    currentCount > 0 &&
    currentCount < minCountWarning;

  const minCountText: ReactNode | null = shouldShowMinWarning ? (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Icon icon="ci:octagon-warning" width="15" />
      <span style={{ fontWeight: '600', lineHeight: 1 }}>
        {t(
          'input_more_details',
          'Please provide more details for better results',
        )}
        {countText && <> {countText}</>}
      </span>
    </div>
  ) : null;

  return { countText, minCountText };
};
